import { render, staticRenderFns } from "./PointMD.vue?vue&type=template&id=0856d1a4&scoped=true"
import script from "./PointMD.vue?vue&type=script&lang=js"
export * from "./PointMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856d1a4",
  null
  
)

export default component.exports